module.exports = new __parcel__URL__("elf-title-talent-4.ee1b68a5.gif").toString();